import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import { createGameRegistryQuery, Game, GameRegistryFilters } from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel, SORT_DIRECTIONS } from 'shared/lib';

export type CreateGameRegistryModelParams = {
	$accountId?: Store<number | null>;
} & RegistryCallbacks;

export type GameRegistryModel = RegistryModel<Game, GameRegistryFilters, JsonApiRequestError>;

export const createGameRegistryModel = ({
	$accountId,
	...params
}: CreateGameRegistryModelParams): GameRegistryModel => {
	const query = createGameRegistryQuery($accountId);

	const model = createRegistryModel({
		query,
		filters: {
			gameIds: [],
			accountIds: [],
		},
		sortField: 'title',
		sortDirection: SORT_DIRECTIONS.ASC,
		...params,
	});

	return model;
};
